// Swaps the Shopify line item thumbnail for the 3D screenshot that the Pacdora
// engine attaches as the `pacdora-image3D` line item property, and hides the
// bookkeeping properties from the customer.

// Line item property labels render as "<dt>{{ property.first }}:</dt>".
var PACDORA_IMAGE_PROPERTY = 'pacdora-image3D:'
var PACDORA_HIDDEN_PROPERTIES = ['pacdora-image3D:', 'pacdora-project-id:']

// .cart-item        -> /cart page rows and cart drawer rows
// #cart-notification-product -> the "added to cart" popup
var PACDORA_ROW_SELECTOR = '.cart-item, #cart-notification-product'

document.addEventListener('DOMContentLoaded', function () {
  switchImage()
  watchCartUpdates()
  watchDrawer()
  watchCartItems()
})

function switchImage() {
  document.querySelectorAll(PACDORA_ROW_SELECTOR).forEach((row) => {
    const image = row.querySelector('img')
    if (!image) return

    row.querySelectorAll('dt').forEach((node) => {
      const label = node.textContent.trim()
      if (!PACDORA_HIDDEN_PROPERTIES.includes(label)) return

      const parentNode = node.parentNode
      if (label === PACDORA_IMAGE_PROPERTY) {
        const ddNode = parentNode.querySelector('dd')
        const url = ddNode && ddNode.textContent.trim()
        if (url) {
          // The screenshot is served off Pacdora's CDN, so the theme's
          // responsive srcset no longer applies — drop it or it wins over src.
          image.removeAttribute('srcset')
          image.removeAttribute('sizes')
          image.src = url
        }
      }
      parentNode.hidden = true
    })
  })
}

// The theme broadcasts this after every cart mutation (add, change, remove),
// which covers the drawer, the notification popup and the cart page at once.
function watchCartUpdates() {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    // Let the theme finish swapping in the new markup first.
    requestAnimationFrame(switchImage)
  })
}

/**
dynamic watch drawer, if drawer is visible, do switchimage
**/
// 使用MutationObserver监听drawer的可见性变化

function watchDrawer() {
  const containers = document.querySelectorAll('.cart-notification, cart-drawer')
  if (containers.length === 0) return

  containers.forEach((container) => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'style' || mutation.attributeName === 'class') {
          const isVisible = window.getComputedStyle(container).visibility === 'visible'
          if (isVisible) {
            switchImage()
          }
        }
      })
    })

    observer.observe(container, { attributes: true, attributeFilter: ['style', 'class'] })
  })
}

function watchCartItems() {
  // .cart-items for cart item in cart page
  const form = document.querySelector('form#cart')
  if (!form) {
    return
  }

  const observer = new MutationObserver((mutations) => {
    const hasNewRows = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === 1 &&
          (node.matches(PACDORA_ROW_SELECTOR) || node.querySelector(PACDORA_ROW_SELECTOR))
      )
    )
    if (hasNewRows) switchImage()
  })

  observer.observe(form, { childList: true, subtree: true })
}
